import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { Calendar } from 'primeng/calendar';
import Cleave from 'cleave.js';
import moment from 'moment';
import { MIN_DOCUMENT_DATE, MAX_DOCUMENT_DATE } from '../constants';

@Directive({
  selector: 'p-calendar[appPrimeNgCalendarMask]',
})
export class PrimeNgCalendarMaskDirective implements AfterViewInit {
  cleave: Cleave;
  @Input() formatInputMaskType: string = 'date';

  constructor(private el: ElementRef, private host: Calendar) {}

  ngAfterViewInit() {
    let options = {};
    switch (this.formatInputMaskType) {
      case 'date':
        options = {
          date: true,
          delimiter: '.',
          dateMax: moment(MAX_DOCUMENT_DATE).format('YYYY-MM-DD'),
          datePattern: ['d', 'm', 'Y'],
        };
        break;
      case 'time':
        options = {
          time: true,
          timePattern: ['h', 'm'],
        };
        break;
      case 'dateTime':
        options = {
          numericOnly: true,
          delimiters: ['.', '.', ' ', ':'],
          blocks: [2, 2, 4, 2, 2],
        };
        break;
    }
    this.cleave = new Cleave(this.host.inputfieldViewChild.nativeElement, options);
  }
}
